import { cn } from "@omni/utils/styles";

type Props = {
    icon: string;
    disabled: boolean;
    onClick?: any;
    className?: any;
    innerRef?: any;
};

export const NavButton = ({
    icon,
    disabled,
    onClick,
    className,
    innerRef
}: Props) => (
    <div
        className={cn(
            "tw:text-primary tw:cursor-pointer tw:text-3xl",
            { "tw:cursor-default tw:opacity-20 tw": disabled },
            className
        )}
        ref={innerRef}
        onClick={() => onClick?.()}
    >
        <i className={cn(`las la-angle-${icon}`, "tw:-translate-y-1/2")} />
    </div>
);
